import { compose } from 'react-apollo';
import { withStepStatus } from '@rosetta/gaia-progress';
import { withStepData } from './withStepData';
import { withStepPlayer } from './player/withStepPlayer';
import { withPlayerInitializer } from './player/withPlayerInitializer';

/**
 * Combine all step related (common) HOCs in one to avoid
 * repeating `connects` at every step component.
 */

export var withStep = function withStep() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return function (WrappedComponent) {
    return compose.apply(undefined, [withStepStatus, withStepPlayer, withStepData].concat([].concat(args, [withPlayerInitializer])))(WrappedComponent);
  };
};